export default __webpack_public_path__ + "static/media/IBMFile.a0b0c7ab.svg";